// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"293359ae","569":"293359ae","590":"293359ae","774":"293359ae","789":"293359ae","804":"0eeb78d2","994":"293359ae"}[chunkId] + ".chunk.css";
};